module.exports = __webpack_public_path__ + "site/img/48.93fb74f2.jpg";